import { LayoutSlotConfig } from '@spartacus/storefront';

export const layoutSlotsConfig: LayoutSlotConfig = {
  header: {
    slots: ['Header']
  },
  footer: {
    slots: ['ReinsuranceFooter', 'NewsletterSocialFooter', 'NavigationFooter', 'LegalFooter']
  },
  AccessoriesHomePageTemplate: {
    slots: ['Arguments', 'DynamicBody']
  },
  CategoryPageTemplate: {
    slots: ['DynamicBody1', 'DynamicBody2', 'DynamicBody3']
  },
  HomePageTemplate: {
    slots: ['DynamicBody', 'SEO']
  },
  ProductDetailsPageTemplate: {
    slots: ['SEO', 'ApplicationAndArguments', 'PushPromo', 'ProductBody', 'WhatsInTheBox']
  },
  PromoBanners: {
    slots: ['PushBanner']
  },
  SubCategoryPageTemplate: {
    slots: ['Reinsurance', 'PushCard']
  },
  NewGenerationTemplate: {
    slots: ['DynamicBody', 'SEO']
  },
  StoreLocatorPageTemplate: {
    slots: ['StoreLocator']
  },
  EmptyPageTemplate: {
    slots: ['FreeZone']
  },
  ServicePageTemplate: {
    slots: ['Navigation', 'DynamicBody', 'SEO', 'FaqWithTransport', 'FaqWithoutTransport']
  },
  ProductComparatorPageTemplate: {
    slots: ['ProductComparator']
  },
  AccountPageTemplate: {
    slots: ['NavigationAccount', 'SEO', 'DynamicBody']
  },
  CartPageTemplate: {
    slots: ['Stepper', 'ShoppingCart', 'CrossSell', 'SEO', 'DeliveryModule', 'Reinsurance', 'WarningSlot']
  },
  RecipeDetailsPageTemplate: {
    slots: ['SEO']
  },
  RecipeListPageTemplate: {
    slots: ['SEO']
  },
  RecipeCategoryPageTemplate: {
    slots: ['Title', 'RecipeList']
  },
  SalesConditionsPageTemplate: {
    slots: ['DynamicBody']
  },
  RepairDocumentsPageTemplate: {}
};
